<script lang="ts" setup>
import AppFooter from '~/app/components/Layout/AppFooter.vue'
import AppHeader from '~/app/components/Layout/AppHeader.vue'

const route = useRoute()

const ui = computed(() => {
  const mainWidth
    = route.meta.layoutContainer === 'full'
      ? 'max-w-full'
      : 'max-w-(--ui-container)'

  return {
    main: mainWidth + 'm-auto w-full',
  }
})
</script>

<template lang="html">
  <div class="default-layout flex h-full min-h-full flex-col pb-[calc(4.75rem+env(safe-area-inset-bottom,0px))] lg:pb-0">
    <AppHeader />

    <main :class="[ui.main, 'flex flex-1 flex-col']">
      <slot />
    </main>

    <AppFooter />
  </div>
</template>
